import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IInsuredPersonsState, IPolicies, TError } from './types/InsuredPersons-interface'

const InsuredPersonsListState = (state: RootState): IInsuredPersonsState => state.insuredPersons

export const InsuredPersonsList = createSelector(
    [InsuredPersonsListState],
    (state): IPolicies[] => state.Policies,
)
export const PolicyCount = createSelector(
    [InsuredPersonsListState],
    (state): number => state.PolicyCount,
)
export const LoadingPolicies = createSelector(
    [InsuredPersonsListState],
    (state): boolean => state.isLoadingPolicies,
)
export const ErrorPolicies = createSelector(
    [InsuredPersonsListState],
    (state): TError => state.errorPolicies,
)

export const LastFetchPolicies = createSelector(
    [InsuredPersonsListState],
    (state): null | number => state.lastFetchTime,
)
export const ContractsIDPolicies = createSelector(
    [InsuredPersonsListState],
    (state): string[] | [] => state.contractID,
)

export const CurrentPagePolicies = createSelector(
    [InsuredPersonsListState],
    (state): number => state.currentPage,
)

export const CurrentPagePoliciesInCase = createSelector(
    [InsuredPersonsListState],
    (state): number => state.currentPageInCase,
)

export const Download = createSelector(
    [InsuredPersonsListState],
    (state): boolean => state.isDownload,
)
export const ErrorDownload = createSelector(
    [InsuredPersonsListState],
    (state): TError  => state.errorDownload,
)
export const FileData = createSelector(
    [InsuredPersonsListState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [InsuredPersonsListState],
    (state): string => state.FileName,
)